import { getCustomisationValue, updateCustomisationValue } from "../../../EditablePreview/EditablePreview";
import ModuleNumericalInput from "../../components/ModuleNumericalInput";
import { evaluateDisplayConditionsForField, renderFirstCustomBlock, renderSecondCustomBlock } from "../../customFields/CustomFieldRenderer";
import { changeNumericalFieldValue } from "../../ModuleList";

const DimensionsModule = (props) => {
    const moduleConfig = props.moduleConfig;
    const customisationVars = props.customisationVars;

    const visualisationComponentKey = props.visualisationComponentKey || null;
    const index = props.index ?? 0;

    let dimensionsFieldConfig = null;
    for (let i = 0; i < moduleConfig.fields.length; i++) {
        const field = moduleConfig.fields[i];
        if (field.field.includes('dimensions-dimensions')) {
            dimensionsFieldConfig = field;
        }
    }

    const changeDimensionsFieldValue = (field, value) => {
        if (dimensionsFieldConfig?.[field]) {
            if (changeNumericalFieldValue(customisationVars, dimensionsFieldConfig[field], value, true, index, visualisationComponentKey, props.selectedFeatureNode)) {
                props?.forceUpdateComponent?.();
            }
        }
    }

    const showWidthField = evaluateDisplayConditionsForField(props, dimensionsFieldConfig?.["dimensions-width"]);
    const showHeightField = evaluateDisplayConditionsForField(props, dimensionsFieldConfig?.["dimensions-height"]);
    const completelyHideUnneededFields = moduleConfig?.moduleSettings?.hideUnneededFields ?? false;

    return (
        <div className="v2-basic-module-holder">
            <h5>Dimensions</h5>

            {renderFirstCustomBlock(props)}

        <div className="v2-module-columns-holder">
            <div className='v2-module-one-column v2-full-width'>
                <div className={`v2-module-field-label${!!dimensionsFieldConfig?.["dimensions-width"]?.dataLink || !!dimensionsFieldConfig?.["dimensions-height"]?.dataLink ? '' : ' disabled'}`}>Dimensions</div>
                {(showHeightField || showWidthField || !completelyHideUnneededFields) && 
                    <div className='v2-module-columns-holder'>
                        {(showWidthField || !completelyHideUnneededFields) &&
                            <div className='v2-module-one-column'>
                                <ModuleNumericalInput
                                    fieldLabel="W"
                                    value={getCustomisationValue(customisationVars, dimensionsFieldConfig?.["dimensions-width"]?.dataLink, index, visualisationComponentKey, props.selectedFeatureNode) ?? '-'}
                                    fieldId={dimensionsFieldConfig?.["dimensions-width"]?.dataLink}
                                    enabled={!!dimensionsFieldConfig?.["dimensions-width"]?.dataLink && showWidthField}
                                    onChange={(fieldId, value) => changeDimensionsFieldValue("dimensions-width", value)}
                                />
                            </div>
                        }
                        {(showHeightField || !completelyHideUnneededFields) &&
                            <div className='v2-module-one-column'>
                                <ModuleNumericalInput
                                    fieldLabel="H"
                                    value={getCustomisationValue(customisationVars, dimensionsFieldConfig?.["dimensions-height"]?.dataLink, index, visualisationComponentKey, props.selectedFeatureNode) ?? '-'}
                                    fieldId={dimensionsFieldConfig?.["dimensions-height"]?.dataLink}
                                    enabled={!!dimensionsFieldConfig?.["dimensions-height"]?.dataLink && showHeightField}
                                    onChange={(fieldId, value) => changeDimensionsFieldValue("dimensions-height", value)}
                                />
                            </div>
                        }
                    </div>
                }
            </div>
        </div>

            {renderSecondCustomBlock(props)}

        </div>
    );
}

export default DimensionsModule;
